export enum UserIdentity {
  PROFESSOR = 'PROFESSOR',
  STUDENT = 'STUDENT',
  TUTOR = 'TUTOR',
  RESEARCHERS = 'RESEARCHERS'
}
